module.exports = __webpack_public_path__ + "img/beiyun-icon.631d319c.png";